import React from 'react'
import { ArrowCircleRightIcon } from '@heroicons/react/outline';
import { COLORS } from '../../config';
import { useHistory } from 'react-router';

function OngoingTreatmentCard({ treatment }) {
    const history = useHistory();

    const handleClick = () => history.push('/my-treatments/details', { treatmentInfo: treatment });

    return(
        <div key={treatment._id} className={`flex justify-between bg-gray-100 py-4 px-8 rounded-lg`}>
            <div className='flex-grow mr-2'>
                <p className="text-secondary font-semibold">{treatment.center_of_excellence.name}</p>
                <div className='flex justify-between'>
                    <p className="text-gray-500">{treatment.treatment_type}</p>
                    <p className="text-gray-500">{treatment.patient_id.first_name + ' ' + treatment.patient_id.last_name }</p>
                </div>
            </div>
            <ArrowCircleRightIcon stroke={COLORS.colorPrimary} className='h-6 w-6 -mr-6 my-auto cursor-pointer' onClick={handleClick}/>
        </div>
    )
}

export default OngoingTreatmentCard;